// @flow
import React, { Component } from "react";
import TablePagination from "@material-ui/core/TablePagination";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing.unit * 2.5
  }
});

type PaginationActionsPropsType = {
  classes: { root: DictionaryType },
  onChangePage: Function,
  page: number,
  count: number,
  rowsPerPage: number
};

class PaginationActions extends Component<PaginationActionsPropsType, *> {
  handleFirstPageButtonClick = (event: Event): * => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = (event: Event): * => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = (event: Event): * => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = (event: Event): * => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render(): React$Element<*> {
    const { classes, count, page, rowsPerPage } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          <FirstPageIcon />
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          <LastPageIcon />
        </IconButton>
      </div>
    );
  }
}

const PaginationActionsWrapped = withStyles(styles)(PaginationActions);

type PaginationsPropsType = {
  onChangePage: Function,
  page: number,
  count: number,
  rowsPerPage: number
};

class Paginations extends Component<PaginationsPropsType, *> {
  handleChangePage = (event: Event, page: number) => {
    this.props.onChangePage(page);
  };

  render(): React$Element<*> {
    const { count, page, rowsPerPage } = this.props;

    return (
      <TablePagination
        rowsPerPageOptions={[rowsPerPage]}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={this.handleChangePage}
        ActionsComponent={PaginationActionsWrapped}
      />
    );
  }
}

export default Paginations;
